import clsx from 'clsx';
import { useCurrency } from '@/themes/core/hooks/useCurrency';
/**
 * Price Component
 * Displays formatted price synced with store currency via useCurrency hook
 */
const Price = ({
    amount,
    className,
}: {
    amount: string | number;
    className?: string;
} & React.ComponentProps<'p'>) => {
    const { isConverted, formatDisplayPrice, formatBasePrice } = useCurrency();
    const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

    // We use the new currency system formatBasePrice instead of legacy fallback
    const basePriceFormatted = formatBasePrice(numericAmount);

    return (
        <div className={clsx("flex flex-col items-center justify-center text-center", className)}>
            <p suppressHydrationWarning={true} className="whitespace-nowrap">
                {basePriceFormatted}
            </p>
            {isConverted && (
                <p suppressHydrationWarning={true} className="whitespace-nowrap text-[10px] font-medium opacity-90 mt-0.5 tracking-wider">
                    {formatDisplayPrice(numericAmount)}
                </p>
            )}
        </div>
    );
};

export default Price;
